import axios from "axios";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { server2 } from "../constant/config";
import { useAuthConfig } from "../hooks/useAuthConfig";
import RenderMtp from "../component/mtp/RenderMtp";
import AddMtpModal from "../component/mtp/AddMtpModal";
import Layout from "../layout/Layout";
import Information from "../component/Information";


const MtpAi = () => {
  const [searchParams] = useSearchParams();
  const boardId = searchParams.get("board");
  const subjectId = searchParams.get("subject");
  const gradeId = searchParams.get("class");

  const config = useAuthConfig();

  const [extras, setExtras] = useState({
    loading: false,
    error: null,
    data: null,
    year: "",
    showModal: false,
    mtpContent: "",
    mtpError: null,
    mtpLoading: false,
  });

  const fetchMtpData = async () => {
    if (!extras.year) {
      setExtras((p) => ({ ...p, error: "Please enter a year" }));
      return;
    }

    try {
      setExtras((prev) => ({ ...prev, loading: true, error: null }));

      const res = await axios.get(
        `${server2}/v1/mtpai?board=${boardId}&subject=${subjectId}&class=${gradeId}&year=${extras.year}`,
        config
      );
      const requiredData = res.data.mtp_ais.filter((i)=>i.board_id===Number(boardId) && i.subject_id===Number(subjectId) && i.class_id===Number(gradeId));
      console.log(requiredData);
      console.log(requiredData.length)
      setExtras((prev) => ({
        ...prev,
        data: requiredData,
        loading: false,
      }));
    } catch (error) {
      setExtras((prev) => ({
        ...prev,
        error: error.message || "Failed to fetch MTP data",
        loading: false,
      }));
    }
  };

  const handleAddMtp = async () => {
    if (!extras.year) {
      setExtras((p) => ({ ...p, error: "Please enter a year" }));
      return;
    }

    setExtras((p) => ({ ...p, showModal: true, mtpContent: "", mtpError: null }));
  };

  const handleSubmitMtp = async () => {
    if (!extras.mtpContent.trim()) {
      setExtras((p) => ({ ...p, mtpError: "Please enter MTP content" }));
      return;
    }

    try {
      setExtras((prev) => ({ ...prev, mtpLoading: true, mtpError: null }));

      const response= await axios.post(
        `${server2}/v1/mtpai`,
        {
          board_id: Number(boardId),
          subject_id: Number(subjectId),
          class_id: Number(gradeId),
          year: Number(extras.year),
          paper: extras.mtpContent,
        },
        config
      );
      console.log("MTP Created:", response.data);

      setExtras((prev) => ({
        ...prev,
        mtpLoading: false,
        showModal: false,
        mtpContent: "",
      }));

      alert("MTP Paper created successfully!");
      fetchMtpData();
    } catch (error) {
      setExtras((prev) => ({
        ...prev,
        mtpError: error.message || "Failed to create MTP paper",
        mtpLoading: false,
      }));
    }
  };

  const handleCloseModal = () => {
    setExtras((p) => ({ ...p, showModal: false, mtpContent: "", mtpError: null }));
  };

  return (
    <Layout>
      <Information boardId={boardId} subjectId={subjectId} gradeId={gradeId} />
      <div className="max-w-6xl mx-auto p-6 ">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-gray-800">
            AI Generated MTP Papers
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Generate and view model test papers based on board, class & subject
          </p>
        </div>

        {/* Controls */}
        <div className="bg-white rounded-xl shadow-sm border p-5 flex flex-col md:flex-row gap-4 items-end">
          <div className="flex flex-col w-full md:w-64">
            <label className="text-sm font-medium text-gray-600 mb-1">
              Examination Year
            </label>
            <input
              type="number"
              placeholder="e.g. 2024"
              value={extras.year}
              onChange={(e) =>
                setExtras((prev) => ({ ...prev, year: e.target.value }))
              }
              className="border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <button
            onClick={fetchMtpData}
            disabled={extras.loading}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium disabled:opacity-60"
          >
            {extras.loading ? "Fetching..." : "Show MTP"}
          </button>

          <button
            onClick={handleAddMtp}
            disabled={extras.loading}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-medium disabled:opacity-60"
          >
            {extras.loading ? "Creating..." : "Add MTP"}
          </button>
        </div>

        {/* Error */}
        {extras.error && (
          <div className="mt-4 text-red-600 text-sm bg-red-50 border border-red-200 rounded-lg p-3">
            {extras.error}
          </div>
        )}

        {/* Loading */}
        {extras.loading && (
          <div className="mt-6 text-center text-gray-500">
            Loading MTP papers...
          </div>
        )}

        {/* Data */}
        {extras.data && extras.data.length > 0 && (
          <div className="mt-8 space-y-6">
            {extras.data.map((paper, i) => (
              <RenderMtp
                key={paper.id}
                paper={paper}
                id={paper.id}
                i={i}
              />
            ))}
          </div>
        )}

        {/* Empty State */}
        {extras.data && extras.data.length === 0 && !extras.loading && (
          <div className="mt-6 text-gray-500 text-center">
            No MTP papers found for this year.
          </div>
        )}
      </div>

      {/* Modal */}
      <AddMtpModal
        isOpen={extras.showModal}
        content={extras.mtpContent}
        onContentChange={(content) =>
          setExtras((p) => ({ ...p, mtpContent: content }))
        }
        onSubmit={handleSubmitMtp}
        onClose={handleCloseModal}
        isLoading={extras.mtpLoading}
        error={extras.mtpError}
      />
    </Layout>
  );
};

export default MtpAi;
